module.exports = __webpack_public_path__ + "static/media/TMC-Logo.c599221e.png";